export const frag = /*glsl*/ `
precision mediump float;

uniform sampler2D tNoise;

uniform vec3 uColor;
uniform float uTime;
uniform float uArena;
uniform float uCoolEffectIntensity;
varying vec2 vUv;

#define PI 3.141592

vec3 czm_saturation(vec3 rgb, float adjustment)
{
    return mix(vec3(dot(rgb, vec3(0.2125, 0.7154, 0.0721))), rgb, adjustment);
}
vec3 hueShift(vec3 color, float hue) {
    vec3 k = vec3(0.57735, 0.57735, 0.57735);
    float cosAngle = cos(hue);
    return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
}

float noise(vec2 uv) {
	return sin(cos(uv.x * 6.7) + cos(uv.y * 8.6 + uTime * .001)) * sin(cos(uv.x * 2.7) + cos(uv.y * 2.1 - uTime * .001));
}

void main(){
	float noise = noise(gl_FragCoord.xy * .0004);
	vec3 color = hueShift(uColor, -.8 + noise * .2);
	color = (czm_saturation(color, 2. + noise * .5) * .5 + noise * .05) * .4;
	gl_FragColor = vec4(color - uCoolEffectIntensity * .2, 1.);
}`;
